module.exports = "../../app/cells/components/blog/newsletter_cell.rb";